import { FirefoxIcon } from './FirefoxIcon';

/**
 * author: Contributors
 * id 2A7EE574-62BE-4000-B8D8-B601C29D2960
 * name firefox
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/firefox.svg
 * tags
 * - Brand / Logo 
 */
export const MozillaFirefoxIcon = FirefoxIcon;
export default MozillaFirefoxIcon